export default function youtubePoster(id: any) {
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
}
